<template>
  <!-- A story page's hero scene (data/feature-stories.ts `hero`), server-rendered at its final
       frame and played once on load (StoryScene). The AI chat hero has its own stage
       (StoryChatStage). -->
  <StoryScene :duration="durations[hero] || 6000" :label="label">
    <MotionInboxListWindow v-if="hero === 'inbox'" />
    <MotionIvrSettingsWindow v-else-if="hero === 'ivr'" />
    <MotionPostCallWindow v-else-if="hero === 'postcall'" />
    <MotionCallWindow v-else-if="hero === 'call'" hero />
  </StoryScene>
</template>

<script setup>
defineProps({
  hero: { type: String, required: true },
  label: { type: String, default: "" },
});
// How long each hero plays before Replay shows (ms), kept under 10 s.
const durations = { inbox: 4600, ivr: 3800, postcall: 3400, call: 3200 };
</script>
